import React from 'react';
import {MessageCircleDashed as MessageCircle} from 'lucide-react';

const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/447308538351"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:bg-[#128C7E] transition-all duration-300 hover:scale-110 animate-bounce"
      aria-label="Contact us on WhatsApp"
      style={{ animationDuration: '2s' }}
    >
      <MessageCircle className="w-8 h-8" />
      <span className="absolute -top-2 -right-2 bg-[#FFD700] text-[#333333] text-xs font-bold px-2 py-1 rounded-full">
        Chat
      </span>
    </a>
  );
};

export default WhatsAppFloat;
